import React from "react";
import { useTranslation } from "react-i18next";
import { GeneralImage } from "../../../../components";
import drug_img from "../../../../assets/images/drug_test.png";

interface SearchDrugCardProps {
  item: any;
  isFullStyle?: boolean;
}

const SearchDrugCard: React.FC<SearchDrugCardProps> = ({
  item,
  isFullStyle,
}) => {
  const { t } = useTranslation();
  return (
    <div
      className={`flex flex-col gap-4 ${isFullStyle && "rounded-lg bg-Gray p-3"}`}
    >
      <div className="flex gap-3 rounded-lg bg-white p-2">
        <GeneralImage
          alt={item?.DrugName}
          imageToLoad={drug_img}
          className="h-9 w-9 rounded-full object-cover"
          src={item?.Image}
          width="36px"
        />
        <div className="flex flex-col">
          <span className="text-primary-textFont text-sm font-bold">
            {item?.DrugName + " " + item?.PackageName}
          </span>
          <span className="text-xs text-secondaryDark">{item?.Facility}</span>
        </div>
      </div>
      {isFullStyle && (
        <div>
          {item?.DosageForm && (
            <div className="flex px-2 py-1 text-sm text-secondaryDark">
              <span className="w-1/2">{t("dosage")}</span>
              <span className="text-primary-textFont w-1/2 font-semibold">
                {item?.DosageForm}
              </span>
            </div>
          )}
          {item?.Frequency && (
            <div className="flex rounded-md bg-white px-2 py-1 text-sm text-secondaryDark">
              <span className="w-1/2">{t("frequency")}</span>
              <span className="text-primary-textFont w-1/2 font-semibold">
                {item?.Frequency}
              </span>
            </div>
          )}
          {item?.Instructions && (
            <div className="flex px-2 py-1 text-sm text-secondaryDark">
              <span className="w-1/2">{t("note")}</span>
              <span className="text-primary-textFont w-1/2 font-semibold">
                {item?.Instructions}
              </span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default SearchDrugCard;
